<ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
  <ng-container *ngFor="let menu of menuItems">
    <li
      *ngIf="!(menu?.items && menu.items?.length)"
      nz-menu-item
      nz-tooltip
      nzTooltipPlacement="right"
      [nzTooltipTitle]="isCollapsed ? menu.title : ''"
      [nzSelected]="selectItem && selectItem === menu.title"
      nzTooltipOverlayClassName="menu-tooltip"
      (click)="onMenuClick.emit({ target: menu })"
    >
      <i
        *ngIf="menu?.icon"
        nz-icon
        [class.digi-menu-icon]="menu.icon && menu.icon.indexOf('digi') !== -1"
        [nzType]="
          menu.icon && menu.icon.indexOf('digi') !== -1
            ? 'ng-zorro:' + menu.icon
            : menu.icon || ''
        "
      >
      </i>
      <span
        class="digi-menu-label"
        [title]="menu.title"
        [class.digi-menu-width]="menu.icon"
        >{{ menu.title }}</span
      >
    </li>
    <li
      *ngIf="menu?.items && menu.items?.length"
      nz-submenu
      [nzOpen]="true"
      class="digi-menu-item"
      [class.digi-menu-item-width]="menu.icon"
      [class.digi-menu-icon]="menu.icon && menu.icon.indexOf('digi') !== -1"
      [nzTitle]="menu.title"
      [title]="menu.title"
      [nzIcon]="
        menu.icon && menu.icon.indexOf('digi') !== -1
          ? 'ng-zorro:' + menu.icon
          : menu.icon || ''
      "
    >
      <ul>
        <li
          nz-menu-item
          *ngFor="let item of menu.items"
          [nzSelected]="selectItem && selectItem === item.title"
          (click)="onMenuClick.emit({ target: item, parent: menu })"
        >
          <i
            *ngIf="item?.icon"
            nz-icon
            [class.digi-menu-icon]="
              item.icon && item.icon.indexOf('digi') !== -1
            "
            [nzType]="
              item.icon && item.icon.indexOf('digi') !== -1
                ? 'ng-zorro:' + item.icon
                : item.icon || ''
            "
          >
          </i>
          <span
            class="digi-menu-label"
            [title]="item.title"
            [class.digi-menu-width]="item.icon"
            >{{ item.title }}</span
          >
        </li>
      </ul>
    </li>
  </ng-container>
</ul>
